import axios from "axios";
import { jwtDecode } from "jwt-decode";

const isLocal =
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");

const baseURL =
  process.env.REACT_APP_API_BASE_URL ||
  (isLocal ? "http://localhost:8888" : "https://api.recettes.io");

function getUsableAccessToken() {
  const token = localStorage.getItem("access_token");
  if (!token || token === "null" || token === "undefined") return null;

  try {
    const decoded = jwtDecode(token);
    if (decoded.exp && decoded.exp * 1000 <= Date.now() + 30000) {
      localStorage.removeItem("access_token");
      return null;
    }
    return token;
  } catch {
    localStorage.removeItem("access_token");
    return null;
  }
}

function attachAuthToken(instance) {
  instance.interceptors.request.use(
    (config) => {
      const token = getUsableAccessToken();
      config.headers = config.headers || {};

      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      } else if (config.headers.Authorization) {
        delete config.headers.Authorization;
      }

      return config;
    },
    (error) => Promise.reject(error)
  );
}

const api = axios.create({
  baseURL,
  withCredentials: true,
  timeout: 15000,
});

export const apiAuth = axios.create({
  baseURL,
  withCredentials: true,
  timeout: 15000,
});

attachAuthToken(api);
attachAuthToken(apiAuth);

export default api;
